import { Component, OnInit, Input } from '@angular/core';
import LengthAwarePaginator from '../../models/LengthAwarePaginator';

@Component({
  selector: 'vicoders-activity-log',
  templateUrl: './activity-log.component.html',
  styleUrls: ['./activity-log.component.css']
})
export class ActivityLogComponent implements OnInit {
  @Input() items: any[];
  @Input() paginator: LengthAwarePaginator;

  constructor() {}

  ngOnInit() {}
}
